/*  販売開始通知ボタン（[data-launch-notify-button]）の登録・解除を launch-notify アプリの API で行う。 */
(function () {
  var ENDPOINT = '/apps/account/launch-notify/registrations';
  var BUTTON_SELECTOR = '[data-launch-notify-button]';
  var LABELS = {
    register: '販売開始のお知らせを受け取る',
    unregister: '販売開始のお知らせを解除する',
    beforeSale: '販売開始前'
  };
  var MESSAGES = {
    registered: '販売開始通知を登録しました！',
    saleStartsOn: '{date}に販売を開始します',
    tooManyRegistrations: 'お知らせを登録できる件数の上限に達しています。',
    failed: '処理に失敗しました。時間をおいて再度お試しください。'
  };

  function callApi(method, productId) {
    var url = ENDPOINT;
    var options = {
      method: method,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    };

    if (method === 'GET') {
      url += '?product_ids=' + encodeURIComponent(productId);
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify({ product_id: productId });
    }

    return fetch(url, options)
      .then(function (response) {
        return response.json()
          .catch(function () {
            return null;
          })
          .then(function (json) {
            return { status: response.status, ok: response.ok, json: json };
          });
      })
      .catch(function () {
        return { status: 0, ok: false, json: null };
      });
  }

  function isSuccess(result) {
    return result.ok && !!result.json && result.json.ok === true;
  }

  function getErrorCode(result) {
    return result.json && result.json.code ? result.json.code : '';
  }

  function isLoggedIn(button) {
    return button.getAttribute('data-customer-logged-in') === 'true';
  }

  function setMessage(button, text) {
    var container = button.parentElement;
    var messageEl = container && container.querySelector('[data-launch-notify-message]');
    if (messageEl) messageEl.textContent = text || '';
  }

  function setBusy(button, busy) {
    button.disabled = busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  /** 未登録は塗り（button--primary）、登録済みは枠線（button--border-primary）で表示する */
  function renderRegistered(button, registered) {
    button.setAttribute('data-registered', registered ? 'true' : 'false');
    button.textContent = registered ? LABELS.unregister : LABELS.register;
    button.classList.toggle('button--primary', !registered);
    button.classList.toggle('button--border-primary', registered);
  }

  function alertRegistered(button) {
    var startsOn = button.getAttribute('data-sale-starts-on');
    var message = MESSAGES.registered + (startsOn ? MESSAGES.saleStartsOn.replace('{date}', startsOn) : '');
    window.setTimeout(function () {
      window.alert(message);
    }, 0);
  }

  function redirectToLogin(button) {
    var url = new URL(button.getAttribute('data-login-url') || '/customer_authentication/login', window.location.origin);
    url.searchParams.set('return_to', window.location.pathname + window.location.search);
    window.location.href = url.pathname + url.search;
  }

  function showUnavailable(button) {
    button.setAttribute('data-launch-notify-unavailable', 'true');
    button.setAttribute('hidden', '');
    setMessage(button, '');

    var block = button.closest('[data-block-type="buy-buttons"]');
    var notPurchaseBtn = block && block.querySelector('#jsButtonNotPurchase');
    if (notPurchaseBtn) {
      notPurchaseBtn.textContent = LABELS.beforeSale;
      notPurchaseBtn.removeAttribute('hidden');
    }
  }

  function handleError(button, result) {
    var code = getErrorCode(result);

    if (result.status === 401) {
      redirectToLogin(button);
      return;
    }
    if (code === 'APP_NOT_INSTALLED') {
      showUnavailable(button);
      return;
    }
    if (code === 'TOO_MANY_REGISTRATIONS') {
      setMessage(button, MESSAGES.tooManyRegistrations);
      return;
    }
    setMessage(button, MESSAGES.failed);
  }

  function syncButton(button) {
    if (button.hasAttribute('data-launch-notify-synced')) return;
    button.setAttribute('data-launch-notify-synced', 'true');

    if (!isLoggedIn(button) || button.getAttribute('data-before-sale-start') !== 'true') return;

    var productId = button.getAttribute('data-product-id');
    setBusy(button, true);

    callApi('GET', productId).then(function (result) {
      setBusy(button, false);

      if (isSuccess(result)) {
        var registeredIds = (result.json.data && result.json.data.registered) || [];
        renderRegistered(button, registeredIds.indexOf(String(productId)) !== -1);
        return;
      }
      if (getErrorCode(result) === 'APP_NOT_INSTALLED') {
        showUnavailable(button);
        return;
      }
      renderRegistered(button, false);
    });
  }

  function syncButtons() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(syncButton);
  }

  function onClick(event) {
    var button = event.target.closest(BUTTON_SELECTOR);
    if (!button || button.disabled) return;

    if (!isLoggedIn(button)) {
      redirectToLogin(button);
      return;
    }

    var productId = button.getAttribute('data-product-id');
    var registered = button.getAttribute('data-registered') === 'true';

    setMessage(button, '');
    setBusy(button, true);

    callApi(registered ? 'DELETE' : 'POST', productId).then(function (result) {
      setBusy(button, false);

      if (isSuccess(result)) {
        var nowRegistered = !!(result.json.data && result.json.data.registered === true);
        renderRegistered(button, nowRegistered);
        if (!registered && nowRegistered) alertRegistered(button);
        return;
      }
      handleError(button, result);
    });
  }

  function containsButton(node) {
    return node.nodeType === 1 && (node.matches(BUTTON_SELECTOR) || !!node.querySelector(BUTTON_SELECTOR));
  }

  function observeAddedButtons() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          if (containsButton(addedNodes[j])) {
            syncButtons();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    syncButtons();
    observeAddedButtons();
  }

  document.addEventListener('click', onClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
